import {
  REFERRAL_PARAMS,
  REFERRAL_SESSION_STORAGE_KEY,
  ReferralSource,
  type ReferralDataType,
} from '../../defs';

/**
 * Captures cookbook-referral attribution params from the landing URL into
 * session storage so they survive the journey to signup (mirrors UTM capture).
 *
 * First-touch: once a referral is stored it is not overwritten. URLs without any
 * referral params are ignored, so a non-referral page visited first does not
 * clobber a later referral-link visit.
 */
export function setReferralSessionStorage(searchParams: string) {
  const params = new URLSearchParams(searchParams);

  const rawSource = params.get(REFERRAL_PARAMS.referral_source);
  const cookbookUserId = params.get(REFERRAL_PARAMS.referral_cookbook_user_id);
  const linkId = params.get(REFERRAL_PARAMS.referral_link_id);

  // Nothing referral-related on this URL — leave any earlier capture intact.
  if (rawSource === null && cookbookUserId === null && linkId === null) {
    return;
  }

  // First referral wins; don't clobber an earlier attribution.
  if (sessionStorage.getItem(REFERRAL_SESSION_STORAGE_KEY) !== null) {
    return;
  }

  const parsedSource = ReferralSource.safeParse(rawSource);

  const referralData: ReferralDataType = {
    referral_source: parsedSource.success ? parsedSource.data : null,
    referral_cookbook_user_id: cookbookUserId,
    referral_link_id: linkId,
  };

  sessionStorage.setItem(
    REFERRAL_SESSION_STORAGE_KEY,
    JSON.stringify(referralData)
  );
}
